import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Moon } from 'lucide-react';
export function TransformationSection() {
  const comparisons = [{
    before: 'Das vueltas 1–2 horas antes de dormir',
    after: 'Te quedas dormida en 20 minutos'
  }, {
    before: 'Te despiertas a las 3AM con miedo',
    after: 'Si despiertas, tienes el Template 3 listo'
  }, {
    before: 'Amaneces con la cara hinchada y el humor roto',
    after: 'Despiertas descansada, con energía real'
  }, {
    before: 'La ansiedad financiera te golpea en la oscuridad',
    after: 'Tu mente cierra el día — y lo deja en papel'
  }, {
    before: 'Sientes que te estás "apagando"',
    after: 'Recuperas a la mujer que eres cuando descansas'
  }];
  const timeline = [{
    night: 'Noche 1–2',
    desc: 'Instalas el ritual. Tu cuerpo empieza a reconocer la señal de calma.'
  }, {
    night: 'Noche 3',
    desc: 'Sueño hormonal más profundo. Menos despertares a las 3AM.'
  }, {
    night: 'Noche 5',
    desc: 'Despiertas descansada. Con energía real para el día que viene.'
  }];
  return <section className="py-20 px-4 md:px-8 bg-cream-100 text-navy-900" data-id="element-296">
      <div className="max-w-5xl mx-auto" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-298">
          <span className="text-4xl mb-4 block" data-id="element-299">✨</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-300">
            SECCIÓN 3 — LA TRANSFORMACIÓN
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-301">
            "Tu Noche — Antes y Después"
          </h3>
          <p className="text-xl text-navy-700" data-id="element-302">Lo que cambia en 5 noches:</p>
        </motion.div>

        {/* Before/After Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-303">
          {/* Before Column */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-red-100" data-id="element-304">
            <div className="bg-red-50 p-4 border-b border-red-100 text-center" data-id="element-305">
              <h4 className="text-red-700 font-bold text-xl" data-id="element-306">🔴 ANTES</h4>
            </div>
            <div className="p-6 space-y-6" data-id="element-307">
              {comparisons.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-308">
                  <X className="h-5 w-5 text-red-400 mt-1 flex-shrink-0" data-id="element-309" />
                  <p className="text-navy-800" data-id="element-310">{item.before}</p>
                </div>)}
            </div>
          </div>

          {/* After Column */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-green-100 transform md:-translate-y-4" data-id="element-311">
            <div className="bg-green-50 p-4 border-b border-green-100 text-center" data-id="element-312">
              <h4 className="text-green-700 font-bold text-xl" data-id="element-313">🟢 DESPUÉS</h4>
            </div>
            <div className="p-6 space-y-6" data-id="element-314">
              {comparisons.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-315">
                  <Check className="h-5 w-5 text-green-500 mt-1 flex-shrink-0" data-id="element-316" />
                  <p className="text-navy-900 font-medium" data-id="element-317">{item.after}</p>
                </div>)}
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="max-w-3xl mx-auto" data-id="element-318">
          <h3 className="text-2xl font-serif font-bold text-center mb-10" data-id="element-319">
            El mapa de tus 5 noches:
          </h3>
          <div className="space-y-6" data-id="element-320">
            {timeline.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex items-center gap-6 bg-white p-6 rounded-xl shadow-md border-l-4 border-gold-500" data-id="element-321">
                <div className="bg-navy-900 text-gold-500 p-3 rounded-full flex-shrink-0" data-id="element-322">
                  <Moon className="h-6 w-6" data-id="element-323" />
                </div>
                <div data-id="element-324">
                  <h4 className="font-bold text-lg text-navy-900 mb-1" data-id="element-325">
                    {item.night}
                  </h4>
                  <p className="text-navy-700" data-id="element-326">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-327">
          <blockquote className="text-xl md:text-2xl font-serif italic text-navy-800 max-w-3xl mx-auto" data-id="element-328">
            <span className="text-gold-500 text-4xl" data-id="element-329">"</span>
            Dormí 7 horas seguidas por primera vez en dos años. Me desperté y
            lloré de alegría.
            <span className="text-gold-500 text-4xl" data-id="element-330">"</span>
          </blockquote>
          <p className="mt-4 font-bold text-gold-600" data-id="element-331">
            — Guadalupe, 52 años, Monterrey
          </p>
        </div>
      </div>
    </section>;
}